import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();

export default class SchedulingAPI {

    URI_V1 = "/v1/scheduling"
    URI_V2 = "/v2/scheduling"

    advancedSearch = async (filter: any) => {
        var query = `companyId=${new CompanyAPI().getCompanyManagment().id}&viewType=${filter.viewType.toUpperCase()}`;

        if (filter.startDate) {
            query += `&startDate=${filter.startDate}`
        }

        if (filter.endDate) {
            query += `&endDate=${filter.endDate}`
        }

        if (filter.employeeId) {
            query += `&employeeId=${filter.employeeId}`
        }

        return await apiService.get(`${this.URI_V1}/advancedSearch?${query}`);
    };

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/employee-created`, data);
    };

    createByEmployee = async (data: any) => {
        return await apiService.post(`${this.URI_V2}/employee`, data);
    };

    updateByEmployee = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V2}/${id}/employee`, data);
    };

    generateCommand = async (id: any, payload: any) => {
        return await apiService.post(`${this.URI_V1}/${id}/generate-command`, payload);
    };


    canceledScheduling = async (id: any, employeeId: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}?employeeId=${employeeId}`);
    };

    createRecurringSchedule = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/recurring-schedule?companyId=${new CompanyAPI().getCompanyManagment().id}`, data);
    };

    getAllRecurring = async () => {
        return await apiService.get(`${this.URI_V1}/recurring-schedule?companyId=${new CompanyAPI().getCompanyManagment().id}`);
    };

    deleteRecurring = async (recurringId: any) => {
        return await apiService.delete(`${this.URI_V1}/recurring-schedule/${recurringId}`);
    };

    getSchedulingByToken = async (token: any) => {
        return await apiService.get(`${this.URI_V1}/confirm-data/${token}`);
    };

    updateScheduling = async (token: any, status: any) => {
        return await apiService.patch(`${this.URI_V1}/confirm-data/${token}/${status}`, null);
    };

    findById = async (id: any) => {
        return await apiService.get(`${this.URI_V1}/${id}`);
    };

    findByGroupId = async (groupId: any) => {
        return await apiService.get(`${this.URI_V1}/${groupId}/groupBy`);
    };

    getCloseDiary = async (filter: any) => {
        var query = `companyId=${new CompanyAPI().getCompanyManagment().id}&viewType=${filter.viewType.toUpperCase()}`;

        if (filter.startDate) {
            query += `&startDate=${filter.startDate}`
        }

        if (filter.endDate) {
            query += `&endDate=${filter.endDate}`
        }

        if (filter.employeeId) {
            query += `&employeeId=${filter.employeeId}`
        }

        return await apiService.get(`${this.URI_V1}/close-diary?${query}`);
    };

    getClubs = async (commandId: any) => {
        return await apiService.get(`${this.URI_V1}/command/${commandId}/clubs`);
    };

    getPackages = async (commandId: any) => {
        return await apiService.get(`${this.URI_V1}/command/${commandId}/packeges`);
    };

}
